<template>
	<el-form :model="formData" ref="form" :rules="formRules">
		<el-row :gutter="20">
			<el-col :span="12">
				<el-form-item :label="$t('meeting.meeting-type')" prop="meetingType">
					<el-select v-model="formData.meetingType" 
				    :placeholder="$t('contract.alias-ph')" style="width:100%"
				    :clearable="true">
					    <el-option
					      v-for="item in meetingType"
					      :key="item.id"
					      :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
			</el-col>
			<el-col :span="12">
              <el-form-item :label="$t('offer.client')" prop="clientName">
                <el-autocomplete
                      v-model="formData.clientName"
                      :fetch-suggestions="querySearchClient"
                      :placeholder="$t('offer.ph')"
                      @select="handleSelectClient"
                      style="width:100%"
                      :clearable="true"
                    >
                    <template slot-scope="{ item }">
                        <div>{{ item.company }}
                          <div class="text-muted">
                            {{ item.clientOfficialName }}
                          </div>
                        </div>
                    </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="12">
				<el-form-item :label="$t('meeting.date')" prop="date">
                	<el-date-picker
				      type="date"
				      v-model="formData.date"
				      :placeholder="$t('meeting.date-ph')"
				      :picker-options="dayOptions"
				      value-format="yyyy-MM-dd"
				      style="width:100%">
				    </el-date-picker>
              	</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item :label="$t('meeting.time')" prop="timeRange">
				  <el-time-picker
				    is-range
				    v-model="formData.timeRange"
				    :range-separator="$t('meeting.to')"
				    :start-placeholder="$t('meeting.start-time')"
				    :end-placeholder="$t('meeting.end-time')"
				    format="HH:mm"
				    value-format="HH:mm:ss"
				    style="width:100%">
				  </el-time-picker>
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<div style="text-align: center">
		            <el-transfer 
		            	filterable
		    			:filter-method="filterMethod"
		 				v-model="formData.attendees"
		 				:titles="[$t('client.user-list'), $t('client.invitee')]"
		 				:data="userData"
		 				style="text-align: left; display: inline-block">
		 			</el-transfer>
	 			</div>
			</el-col>
			<el-col :span="24">
				<el-form-item :label="$t('meeting.comment')" prop="comment">
					<el-input
					  type="textarea"
					  :autosize="{ minRows: 2, maxRows: 4}"
					  v-model="formData.comment"
					  style="width:100%">
					</el-input>
				</el-form-item>
			</el-col>
		</el-row>
	</el-form>
</template>
<style scoped>
</style>
<script>
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'MeetingForm',
  props: ['event', 'users'],
  data: function() {
	return {
	  formData: {
        'id': null,
        'userId': null,
        'resourceId': null,
        'date': moment().format('YYYY-MM-DD'),
        'timeRange': ['10:00:00', '11:00:00'],
        'allDay': false,
        'combined': false,
        'comment': null,
        'participants': null,
        'meetingType': null,
        'recurring': false,
        'repeat': null,
        'ics': true,
        'attendees': [],
        'repeatTime': 1,
        'location': null,
        'clientName': null,
        'clientId': null
      },
	  formRules: {
        'resourceId': [{required: true, message: this.$t('meeting.validate.resource'), trigger: 'blur'}],
        'timeRange': [{required: true, message: this.$t('meeting.validate.range'), trigger: 'blur'}],
        'date': [{required: true, message: this.$t('meeting.validate.date'), trigger: 'blur'}],
        'repeat': [{required: true, message: this.$t('meeting.validate.repeat'), trigger: 'blur'}],
        'meetingType': [{required: true, message: this.$t('meeting.validate.meeting-type'), trigger: 'blur'}]
	  },
	  dayOptions: {
        disabledDate(time) {
          //console.log(time.toJSON().substr(0, 10))
          return time.getTime() < Date.now() - 8.64e7
        }
      },
	}
  },
  computed: {
    isEdit: function() {
      return this.formData.id > 0
    },
    userData: function() {
      let d = []
      this.users.forEach((user, index) => {
        d.push({
          label: user.name,
          key: user.id
        })
      })
      return d
    }
  },
  watch: {
  	"event": function(val) {
  	  //console.log(val)
  	  if (val != null)
  	    this.formData = val
  	  else {
  	    this.formData = {
	        'id': null,
	        'userId': null,
	        'resourceId': null,
	        'date': null,
	        'timeRange': ['10:00:00', '11:00:00'],
	        'allDay': false,
	        'combined': false,
	        'comment': null,
	        'participants': null,
	        'meetingType': null,
            'del': false,
            'recurring': false,
            'repeat': null
	      }
  	  }
  	}
  },
  methods: {
    querySearchClient: function(queryString, cb) {
    	let that = this,
    		query = '?active=0&q=' + encodeURI(queryString) + 
    		'&results_per_page=20&_=' + Date.parse(new Date())

    	this.$http.get(this.API_PREFIX + 'client_list' + query).then(function (response) {
			that.clients = response.data
			
			cb(that.clients)
		}).catch(function (error) {
		    if(error.response) {
		    	switch(error.response.status) {
		    	  case 401:
		    	    //login
		    	    that.$router.push({ path: '/login' })
		    	  	break
		    	}
		    }
			console.log(error)
		})
    },
    handleSelectClient: function(item) {
      this.formData.clientId = item.id
    },
    filterMethod: function(query, item) {
      return item.label.toLowerCase().indexOf(query) > -1
    },
    bookMeetingRoom: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          //close model
          this.formData.userId = localStorage.getItem('token')
          console.log(this.formData)
          let loading = Loading.service({ fullscreen: true }),
              that = this

          //Date Range
          this.formData.timeRange[0] = this.formData.date + ' ' + this.formData.timeRange[0]
          this.formData.timeRange[1] = this.formData.date + ' ' + this.formData.timeRange[1]
          //console.log(this.formData.timeRange)
          if (this.isEdit) {
	          this.$http.put(this.API_PREFIX + 'meeting/' + this.formData.id, this.formData).then(function (response) {
				  that.$nextTick(() => {
					loading.close();
				  })
		          that.$message({
			        message: that.$t('meeting.success'),
			        type: 'success'
			      })
			      that.$refs.form.resetFields()
			      that.$emit('value-save', response.data)
			  }).catch(function (error) {
				console.log(error)
				that.$nextTick(() => {
				  loading.close();
				})
				let msg = that.$t('meeting.failed')
			    if(error.response) {
			    	switch(error.response.status) {
			    	  case 403:
			    	    msg = that.$t('meeting.validate.impact')
			    	  break
			    	}
			    	that.$message({
			          message: msg,
			          type: 'error'
			        })
			    }
		      })
		  } else {
		      this.$http.post(this.API_PREFIX + 'meeting', this.formData).then(function (response) {
				  that.$nextTick(() => {
					loading.close();
				  })
		          that.$message({
			        message: that.$t('meeting.success'),
			        type: 'success'
			      })
			      that.$refs.form.resetFields()
			      that.$emit('value-save', response.data)
			  }).catch(function (error) {
				console.log(error)
				that.$nextTick(() => {
				  loading.close();
				})
				let msg = that.$t('meeting.failed')
			    if(error.response) {
			    	switch(error.response.status) {
			    	  case 403:
			    	    msg = that.$t('meeting.validate.impact')
			    	  break
			    	}
			    	that.$message({
			          message: msg,
			          type: 'error'
			        })
			    }
		      })
		  }
        } else {
          // do stuff if not valid.
          this.$message({
	          message: this.$t('meeting.invalid'),
	          type: 'error'
	        })
          return false
        }
      })
    }
  },
  created: function() {
    if (this.event != null)
  	    this.formData = this.event

  	console.log(this.users)
  }
}
</script>